import { render, staticRenderFns } from "./ListSystem.vue?vue&type=template&id=61fcc13a&"
import script from "./ListSystem.vue?vue&type=script&lang=js&"
export * from "./ListSystem.vue?vue&type=script&lang=js&"
import style0 from "./ListSystem.vue?vue&type=style&index=0&id=61fcc13a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports